import {Paper} from '@mui/material'
import type {FC, ReactNode} from 'react'

/**
 * Lightweight hover tooltip for the chat charts. Absolutely positioned inside a
 * `position:relative` chart wrapper; `left`/`top` are container-relative pixels.
 * Centred above the anchor and click-through (pointerEvents:none).
 */
interface Props {
  left: number
  top: number
  visible: boolean
  children: ReactNode
}

const ChartTooltip: FC<Props> = ({left, top, visible, children}) => {
  if (!visible) return null
  return (
    <Paper
      elevation={4}
      sx={{
        position: 'absolute',
        left,
        top,
        transform: 'translate(-50%, calc(-100% - 12px))',
        px: 1,
        py: 0.5,
        pointerEvents: 'none',
        zIndex: 5,
        maxWidth: 260,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </Paper>
  )
}

export default ChartTooltip
